import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/lems-v1/images/calendar.svg'


const _hoisted_1 = { class: "right-open-issues" }
const _hoisted_2 = { class: "right-open-issues-filters" }
const _hoisted_3 = { class: "custom-row" }
const _hoisted_4 = { class: "open-issues-select" }
const _hoisted_5 = {
  key: 0,
  class: "open-issues-select"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "calendar-drop-down-content" }
const _hoisted_8 = { class: "calendar-drop-down-content-inner" }
const _hoisted_9 = { class: "choose-calendar" }
const _hoisted_10 = { class: "custom-filter" }
const _hoisted_11 = { class: "right-open-issues-list" }
const _hoisted_12 = { class: "right-open-issues-row" }
const _hoisted_13 = {
  key: 0,
  class: "loading-data-text"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "open-issues-content" }
const _hoisted_17 = { class: "open-issues-time" }
const _hoisted_18 = {
  key: 0,
  class: "pagination-box"
}
const _hoisted_19 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("select", {
            class: "v1-selectbox",
            id: "openIssuesSelectBox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedFilter) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
          }, [...(_cache[12] || (_cache[12] = [
            _createStaticVNode("<option value=\"open_issues\">Open issues</option><option value=\"done_issues\">Done issues</option><option value=\"resolved_issues\">Resolved issues</option><option value=\"closed_issues\">Closed issues</option><option value=\"reopened_issues\">Reopened issues</option><option value=\"all\">All issues</option>", 6)
          ]))], 544), [
            [_vModelSelect, _ctx.selectedFilter]
          ])
        ]),
        (!_ctx.isProjectDetailsMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _withDirectives(_createElementVNode("select", {
                class: "v1-selectbox",
                id: "selectProjectSelectBox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedProject) = $event)),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args)))
              }, [
                _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, "Select Project", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: project.key,
                    value: project.key
                  }, _toDisplayString(project.name), 9, _hoisted_6))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.selectedProject]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["calendar-drop-down-box", { 'show-calendar-dropdown': _ctx.isCalendarOpen }])
        }, [
          _createElementVNode("div", {
            class: "calendar-drop-down-icon",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isCalendarOpen = !_ctx.isCalendarOpen))
          }, [...(_cache[14] || (_cache[14] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)
          ]))]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.selectedDate,
                  "onUpdate:modelValue": [
                    _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedDate) = $event)),
                    _ctx.validateDate
                  ],
                  inline: "",
                  "max-date": new Date()
                }, null, 8, ["modelValue", "onUpdate:modelValue", "max-date"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  id: "allCalendarBtn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setDateFilter('all'))),
                  class: _normalizeClass({ active: _ctx.selectedDateFilter === 'all' })
                }, "All", 2),
                _createElementVNode("button", {
                  id: "lastWeekCalendarBtn",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setDateFilter('last_week'))),
                  class: _normalizeClass({ active: _ctx.selectedDateFilter === 'last_week' })
                }, "Last Week", 2),
                _createElementVNode("button", {
                  id: "lastMonthCalendarBtn",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setDateFilter('last_month'))),
                  class: _normalizeClass({ active: _ctx.selectedDateFilter === 'last_month' })
                }, "Last Month", 2),
                _createElementVNode("button", {
                  id: "lastYearCalendarBtn",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setDateFilter('last_year'))),
                  class: _normalizeClass({ active: _ctx.selectedDateFilter === 'last_year' })
                }, "Last Year", 2)
              ])
            ])
          ])
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[15] || (_cache[15] = [
              _createElementVNode("p", null, "Loading issues...", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.issues, (issue) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: issue.id
                }, [
                  _createVNode(_component_router_link, {
                    to: `/employee/issue-detail/${issue.key}`,
                    id: "openIssuesLink"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("i", null, [
                        _createElementVNode("img", {
                          src: issue.fields.issuetype.iconUrl,
                          alt: ""
                        }, null, 8, _hoisted_15)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("strong", null, _toDisplayString(issue.key), 1),
                        _createElementVNode("p", null, _toDisplayString(issue.fields.summary), 1),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.formatRelativeTime(issue.fields.created)), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ]))
      ]),
      (_ctx.totalPages > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("ul", null, [
              (_ctx.currentPage !== 1)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: "pagination-first",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                  }, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("button", { id: "paginationPreButton" }, null, -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_ctx.totalPages != 1)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: page,
                      onClick: ($event: any) => (_ctx.changePage(page))
                    }, [
                      _createElementVNode("a", {
                        href: "#",
                        class: _normalizeClass({ active: _ctx.currentPage === page })
                      }, _toDisplayString(page), 3)
                    ], 8, _hoisted_19))
                  }), 128))
                : _createCommentVNode("", true),
              (_ctx.currentPage !== _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 2,
                    class: "pagination-last",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                  }, [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("button", { id: "paginationNextButton" }, null, -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}